/* tslint:disable */
/* eslint-disable */
/**
 * Compliance
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PendingVerificationLegalEntityResource
 */
export interface PendingVerificationLegalEntityResource {
    /**
     * Client legal entity id
     * @type {string}
     * @memberof PendingVerificationLegalEntityResource
     */
    id: string;
    /**
     * Client organization id
     * @type {string}
     * @memberof PendingVerificationLegalEntityResource
     */
    organizationId: string;
    /**
     * Client organization name
     * @type {string}
     * @memberof PendingVerificationLegalEntityResource
     */
    organizationName?: string;
    /**
     * 
     * @type {string}
     * @memberof PendingVerificationLegalEntityResource
     */
    legalName: string;
    /**
     * 
     * @type {string}
     * @memberof PendingVerificationLegalEntityResource
     */
    registrationNumber: string;
    /**
     * 
     * @type {string}
     * @memberof PendingVerificationLegalEntityResource
     */
    vatIdentificationNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof PendingVerificationLegalEntityResource
     */
    formattedAddress: string;
    /**
     * 
     * @type {string}
     * @memberof PendingVerificationLegalEntityResource
     */
    addressCountryCode: string;
    /**
     * Always NOT_VERIFIED on this endpoint because it only returns legal entities pending manual verification.
     * @type {string}
     * @memberof PendingVerificationLegalEntityResource
     */
    verificationStatus: PendingVerificationLegalEntityResourceVerificationStatusEnum;
    /**
     * 
     * @type {boolean}
     * @memberof PendingVerificationLegalEntityResource
     */
    hasRequestedVerification: boolean;
    /**
     * 
     * @type {Date}
     * @memberof PendingVerificationLegalEntityResource
     */
    lastVerificationRequestSubmittedAt?: Date;
}


/**
 * @export
 */
export const PendingVerificationLegalEntityResourceVerificationStatusEnum = {
    NotVerified: 'NOT_VERIFIED'
} as const;
export type PendingVerificationLegalEntityResourceVerificationStatusEnum = typeof PendingVerificationLegalEntityResourceVerificationStatusEnum[keyof typeof PendingVerificationLegalEntityResourceVerificationStatusEnum];


/**
 * Check if a given object implements the PendingVerificationLegalEntityResource interface.
 */
export function instanceOfPendingVerificationLegalEntityResource(value: object): value is PendingVerificationLegalEntityResource {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('organizationId' in value) || value['organizationId'] === undefined) return false;
    if (!('legalName' in value) || value['legalName'] === undefined) return false;
    if (!('registrationNumber' in value) || value['registrationNumber'] === undefined) return false;
    if (!('formattedAddress' in value) || value['formattedAddress'] === undefined) return false;
    if (!('addressCountryCode' in value) || value['addressCountryCode'] === undefined) return false;
    if (!('verificationStatus' in value) || value['verificationStatus'] === undefined) return false;
    if (!('hasRequestedVerification' in value) || value['hasRequestedVerification'] === undefined) return false;
    return true;
}

export function PendingVerificationLegalEntityResourceFromJSON(json: any): PendingVerificationLegalEntityResource {
    return PendingVerificationLegalEntityResourceFromJSONTyped(json, false);
}

export function PendingVerificationLegalEntityResourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): PendingVerificationLegalEntityResource {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'organizationId': json['organizationId'],
        'organizationName': json['organizationName'] == null ? undefined : json['organizationName'],
        'legalName': json['legalName'],
        'registrationNumber': json['registrationNumber'],
        'vatIdentificationNumber': json['vatIdentificationNumber'] == null ? undefined : json['vatIdentificationNumber'],
        'formattedAddress': json['formattedAddress'],
        'addressCountryCode': json['addressCountryCode'],
        'verificationStatus': json['verificationStatus'],
        'hasRequestedVerification': json['hasRequestedVerification'],
        'lastVerificationRequestSubmittedAt': json['lastVerificationRequestSubmittedAt'] == null ? undefined : (new Date(json['lastVerificationRequestSubmittedAt'])),
    };
}

export function PendingVerificationLegalEntityResourceToJSON(value?: PendingVerificationLegalEntityResource | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'organizationId': value['organizationId'],
        'organizationName': value['organizationName'],
        'legalName': value['legalName'],
        'registrationNumber': value['registrationNumber'],
        'vatIdentificationNumber': value['vatIdentificationNumber'],
        'formattedAddress': value['formattedAddress'],
        'addressCountryCode': value['addressCountryCode'],
        'verificationStatus': value['verificationStatus'],
        'hasRequestedVerification': value['hasRequestedVerification'],
        'lastVerificationRequestSubmittedAt': value['lastVerificationRequestSubmittedAt'] == null ? undefined : ((value['lastVerificationRequestSubmittedAt'] as any).toISOString()),
    };
}

